/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import MediaQuery from 'react-responsive';
import moment from 'moment';
import Timeline from '../../components/Timeline';
import LoadingSpinner from '../../components/Spinners/LoadingSpinner.js';

const Wrapper = styled.div`
  width: 100%;
  padding: 1rem;

  @media (max-width: 767px) {
    padding: 0;
  }
`;

const InstanceDetailsTimeline = ({ requests }) => {
  if (!requests.incidentStatus.isCompleted) return <LoadingSpinner/>;
  const instanceStatus = requests.incidentStatus.value
  const serviceList = {};

  function compare(a, b) {
    let comparison = 0;
    if (a.order > b.order) {
      comparison = 1;
    } else {
      comparison = -1;
    }
    return comparison;
  }

  instanceStatus.Services.sort(compare);
  instanceStatus.Services.forEach((s) => serviceList[s.key] = { incidents: [], maintenances: []})

  instanceStatus.Incidents.forEach((incident) => {
    incident.serviceKeys.forEach((serviceKey) => {
      if (serviceList[serviceKey]){
        serviceList[serviceKey].incidents.push(incident);  
      }
    });
  });

  instanceStatus.Maintenances.forEach((maintenance) => {
    maintenance.serviceKeys.forEach((serviceKey) => {
      if(serviceList[serviceKey]){
        serviceList[serviceKey].maintenances.push(maintenance);  
      }
    });
  });

  return (
    <Wrapper>
      <Timeline serviceList={serviceList} />
    </Wrapper>
  );
};

export default InstanceDetailsTimeline;
